import Decimal from "decimal.js";

import { createRevisionClassResource } from "../../revision";
import { ItemDiff, ResourceItem } from "../ResourceItem";
import {
  apiField,
  constructFromApiData,
  decimalApiField,
  getApiPostData,
  getDiff,
  itemApiField,
  nestedItemArrayApiField,
  revisionItemApiField,
} from "../ResourceItemMetadata";
import { RevisionItem } from "../RevisionItem";
import { Region } from "./Region";
import { Salesperson } from "./Salesperson";

type CzestotliwoscWizyt = 7 | 14 | 28;
export const czestotliwoscWizytOptions: CzestotliwoscWizyt[] = [7, 14, 28];

export type CustomerReference = {
  uuid: string;
  lat: Decimal | null;
  lng: Decimal | null;
};

class NestedAddressData {
  @apiField()
  uuid!: string;

  @apiField()
  name!: string | null;

  @decimalApiField()
  lat!: Decimal | null;
  @decimalApiField()
  lng!: Decimal | null;

  toString() {
    return this.name;
  }

  constructor(data?: any) {
    if (data) {
      constructFromApiData(this, data);
    }
  }

  getDiff(other: this): ItemDiff<this> {
    throw "not implemented";
  }

  getPostData(): any {
    return {
      uuid: this.uuid,
    };
  }
}

export class RouteStop extends ResourceItem {
  @apiField()
  address!: NestedAddressData | CustomerReference;

  @apiField()
  durationMinutes!: number;

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
      this.address = new NestedAddressData(data.address);
    }
  }

  getPostData() {
    return {
      durationMinutes: this.durationMinutes,
      customer: { uuid: this.address.uuid },
    };
  }
}

export class NewRouteStop extends RouteStop {
  constructor(customer: CustomerReference) {
    super();
    this.address = customer;
    this.durationMinutes = 30;
  }
}

function getRouteArrayDiff(a: RouteStop[], b: RouteStop[]) {
  const [longer, shorter] = a.length >= b.length ? [a, b] : [b, a];

  const diff: { [index: number]: boolean } = {};

  longer.forEach((stop, index) => {
    const other = shorter[index];
    if (!other) diff[index] = true;
    else
      diff[index] =
        stop.address.uuid != other.address.uuid || stop.durationMinutes != other.durationMinutes;
  });

  return diff;
}

export class Route extends RevisionItem {
  @apiField()
  name!: string;

  @apiField()
  region!: {
    uuid: string;
    name: string | null;
  };
  @apiField()
  nrInstrukcji!: string;
  @apiField({ inputName: "visitFrequency", outputName: "visitFrequency" })
  czestotliwoscWizyt!: CzestotliwoscWizyt;

  @itemApiField(Salesperson)
  salesperson: Salesperson | null = null;

  // FIXME getDiff
  @nestedItemArrayApiField(RouteStop, { getDiff: getRouteArrayDiff })
  stops: RouteStop[] = [];

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
      this.region.toString = () => this.region.name ?? "Nieznany region";
      (this.region as any).str = this.region.name;
      (this.region as any).id = this.region.uuid;
    }
  }

  toString() {
    return this.id!.toString();
  }

  getPostData() {
    return { ...getApiPostData(this), ...super.getPostData(), region: { uuid: this.region.uuid } };
  }

  getDiff(other: this) {
    return getDiff(this, other);
  }
}

export const routeResource = createRevisionClassResource("crm/route/", Route);
